import {Component, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, Notice} from '../../../types/data.types';
import {NoticesService} from '../../../services/notices.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'create-notice-modal',
    templateUrl: './create-notice-modal.component.html',
    styleUrls: ['./create-notice-modal.component.scss']
})
export class CreateNoticeModalComponent implements OnInit {
    @ViewChild('form') form;
    @ViewChild('pdfFileInput') pdfFileInput;
    @ViewChild('pdfViewer') pdfViewer;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: Notice = new Notice();
    disabledSubmit = false;
    action = 'playlist';
    search = {};
    showFilter: false;
    pdfSrc: string = '';
    message = '';
    public fileIsOver: boolean = false;
    @Output() public options = {
        readAs: 'DataURL'
    };

    constructor(
        public api: ApiClientService,
        public noticesService: NoticesService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        if(this.noticesService.noticeInNoticeModal)
            this.data = this.noticesService.noticeInNoticeModal;
        setTimeout( () => this.initSummernote(), 300);
    }

    hideModal() {
        this.noticesService.isNoticeModalShow = false;
        this.noticesService.noticeInNoticeModal = null;
    }

    getPlaceholdersHtml(): void {

    }

    initSummernote() {
        let summernote;
        if(this.noticesService.wizardType == 'templates')
            summernote = $('#summernote-template');
        else
            summernote = $('#summernote-scratch');
        let scope = this;
        summernote.summernote({
            dialogsInBody: true,
            disableResizeEditor: true,
            // callbacks: { onChange: contents => this.noticesService.noticeInNoticeModal = contents },
            toolbar: [
                // ["style",["style"]],
                ['fontsize', ['fontsize']],
                ['fontname', ['fontname']],
                ['font', ['bold', 'italic', 'underline']],
                ['para', ['paragraph']],
                ['para', ['ul', 'ol']],
                ['misc', ['undo', 'redo']],
                ['color', ['color']],
                ['insert', ['hr', 'icon', 'table']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true,
            buttons: {
                icon: function (context) {
                    return $.summernote.ui.button({
                        contents: '<i class="note-icon-picture"/>',
                        tooltip: 'Insert icons',
                        click: function (e) {
                            context.invoke('editor.saveRange');
                            scope.noticesService.isChooseIconModalShow = true;
                        }
                    }).render();
                }
            }
        });
        $('.note-btn-bold').removeClass('active');

        $('.note-editable').html(this.noticesService.noticeInNoticeModal).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    nextStep(): void {
        this.noticesService.isNoticeModalShow = false;
        this.noticesService.isNoticeScheduleShow = true;
        this.noticesService.firstStep = this.noticesService.step;
        this.noticesService.step = 'schedule';
    }

    back(): void {
        this.noticesService.isNoticeModalShow = false;
        this.noticesService.step = '';
        this.noticesService.isNoticeWizardShow = true;
    }

    launchFilePicker(): void {
        this.pdfFileInput.nativeElement.click();
    }

    onPdfChange(): void {
        let $img: any = document.querySelector('#pdfFileInput');

        if (typeof (FileReader) !== 'undefined') {
            let reader = new FileReader();

            reader.onload = (e: any) => {
                this.pdfSrc = e.target.result;
            };

            reader.readAsArrayBuffer($img.files[0]);
        }
    }

    public fileOver(fileIsOver: boolean): void {
        this.fileIsOver = fileIsOver;
    }

    public onFileDrop(file): void {
        this.pdfSrc = file;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/notices/create-notice-modal/create-notice-modal.component.ts